export default "__VITE_ASSET__CP83fMZV__"